export default "__VITE_ASSET__BAAajZf___"